export const avg = (...values: number[]): number => {
  if (0 === values.length) {
    return 0;
  }

  return values.reduce((prev, value) => prev + value, 0) / values.length;
};

export const round = (num: number, precision: number): number => {
  const precisionToZeros = 10 ** precision;

  return Math.round(num * precisionToZeros) / precisionToZeros;
};

export const toInt = (a: string): number => {
  return parseInt(a) || 0;
};

export const toFloat = (a: string): number => {
  return parseFloat(a) || 0;
};

export const randomNumber = (min: number, max: number, round = false): number => {
  const r = Math.random() * (max - min) + min;
  if (round) {
    return Math.round(r);
  }
  return r;
};

export const convertYearsToWeeks = (value: number): number => round(value * 52, 1);
export const convertWeeksToYears = (value: number): number => round(value / 52, 2);

export const roundToNearest = (value: number, factor = 1): number => factor * Math.round(value / factor);
